import { render, staticRenderFns } from "./calculation.vue?vue&type=template&id=18a3e959&scoped=true"
import script from "./calculation.vue?vue&type=script&lang=js"
export * from "./calculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3e959",
  null
  
)

export default component.exports